import React from 'react';
function Footer(props){
    return(
        <div className="footer">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-auto m-5 b-5 p-5">
                        <p>© Copyright 2024</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Footer;
